// Latest version per template key (rows arrive sorted key asc, version desc).
export const latestPerKey = (rows) => rows.filter((t, i) => i === 0 || rows[i - 1].key !== t.key);
export const isTenantAdmin = (user) => ["OWNER_SUPER_ADMIN", "ADMINISTRATOR"].includes(user?.role_key);
